import { useCallback, useState } from 'react';

/**
 * Custom hook to manage form submission state and prevent multiple submissions
 * @param onSubmit - The form submission handler function
 * @returns Object containing submission state and wrapped submit handler
 */
export const useFormSubmission = <T extends (...args: any[]) => Promise<any> | any>(onSubmit: T) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(
    async (...args: Parameters<T>) => {
      if (isSubmitting) {
        return; // Prevent multiple submissions
      }

      setIsSubmitting(true);
      try {
        await onSubmit(...args);
      } finally {
        setIsSubmitting(false);
      }
    },
    [onSubmit, isSubmitting],
  );

  return {
    isSubmitting,
    handleSubmit,
  };
};
